export default class GAEvent {
  get ui() {
    return {
      metaCurrentUserId: "meta[name=current-user-id]"
    };
  }

  registerEvent(category, action, label, parent, selector, dataSelector, customData, formData, nonInteraction) {
    if(parent === undefined) {
      parent = document.body;
    }

    var eventObject = {category: category, action: action, label: label, dataSelector: dataSelector, customData: customData, formData: formData, nonInteraction: nonInteraction};

    $(parent).on(action, selector, eventObject, (event) => {
      var labelParameter = event.data.label;
      for (var prop in event.data.dataSelector) {
        var data = $(event.currentTarget).data(event.data.dataSelector[prop]);
        labelParameter = labelParameter.replace('[' + prop + ']', data);
      }

      if(event.data.customData !== undefined) {
        event.data.customData.forEach(function(element){
          labelParameter = labelParameter.replace('[' + element + ']', event[element]);
        });
      }

      if(event.data.formData !== undefined) {
        event.data.formData.forEach(function(element){
          labelParameter = labelParameter.replace('[' + element + ']', $(element).val());
        });
      }

      this.sendGAEvent({
        category: event.data.category,
        action: event.data.action,
        label: labelParameter,
        nonInteraction: event.data.nonInteraction
      });
    });
  }

  sendGAEvent(data) {
    var eventParameters = {
      hitType: 'event',
      eventCategory: data.category,
      eventAction: data.action,
      eventLabel: data.label,
      transport: 'beacon',
      nonInteraction: data.nonInteraction || false
    };

    window.ga('kmkGATracker.send', eventParameters);
  }
}
